export const jiraTranslations = {
  // Jira integration
  'jira.title': { en: 'Jira Integration', fi: 'Jira-integraatio' },
  'jira.connect': { en: 'Connect to Jira', fi: 'Yhdistä Jiraan' },
  'jira.disconnect': { en: 'Disconnect from Jira', fi: 'Katkaise Jira-yhteys' },
  'jira.connected': { en: 'Connected to Jira', fi: 'Yhdistetty Jiraan' },
  'jira.connecting': { en: 'Connecting...', fi: 'Yhdistetään...' },
  'jira.myTickets': { en: 'My Tickets', fi: 'Omat tiketit' },
  'jira.noTickets': { en: 'No tickets found', fi: 'Tikettejä ei löytynyt' },
  'jira.loading': { en: 'Loading tickets...', fi: 'Ladataan tikettejä...' },
  'jira.error': { en: 'Error loading Jira data', fi: 'Virhe Jira-datan lataamisessa' },
  'jira.connectionError': { en: 'Failed to connect to Jira', fi: 'Yhteyden muodostaminen Jiraan epäonnistui' },
  'jira.disconnectSuccess': { en: 'Disconnected from Jira successfully', fi: 'Yhteys Jiraan katkaistu onnistuneesti' },
  'jira.status': { en: 'Status', fi: 'Tila' },
  'jira.priority': { en: 'Priority', fi: 'Prioriteetti' },
  'jira.viewInJira': { en: 'View in Jira', fi: 'Avaa Jirassa' },
  'jira.refresh': { en: 'Refresh', fi: 'Päivitä' },
  'jira.analyzing': { en: 'Analyzing ticket...', fi: 'Analysoidaan tikettiä...' },
};